/**
 * Traduction d'une erreur API en message affichable.
 *
 * Le backend renvoie un `code` stable et un `detail` **en anglais, destiné aux
 * développeurs** : on ne montre jamais `detail` (docs/22 §5). Un code inconnu
 * retombe sur un message générique plutôt que sur une chaîne technique.
 */
import { useTranslation } from "react-i18next";

import { ApiError } from "@/shared/api/errors";

export function useApiErrorMessage(): (error: unknown) => string | undefined {
  const { t } = useTranslation();

  return (error: unknown) => {
    if (error === null || error === undefined) {
      return undefined;
    }
    const code = error instanceof ApiError ? error.code : "unexpected_error";
    return t([`errors.${code}`, "errors.unexpected_error"]);
  };
}
